/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { COMPLETED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import { STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { genericAlertFailure, genericAlertSuccess } from '../../../alerts/bulkActionsAlerts';
import { DEFAULT_BULK_ACTIONS_COMPLETE_TASKS_MODAL_KEY } from '../../../constants/modalKeys';
import { useOnBulkUpdateTasks } from '../../../hooks/tasksBulkActionsHooks/tasksCrud';
import { useBulkActionsHasError } from '../../../hooks/useBulkActionsHasError';
import { useBulkActionsIsLoading } from '../../../hooks/useBulkActionsIsLoading';
import { useBulkActionsNumberOfSelectedObjects } from '../../../hooks/useBulkActionsNumberOfSelectedObjects';
import { useBulkActionsOpenModal } from '../../../hooks/useBulkActionsOpenModal';
import { useBulkActionsPermissionsForCurrentSelection } from '../../../hooks/useBulkActionsPermissionsForCurrentSelection';
import { useBulkActionsSelectionState } from '../../../hooks/useBulkActionsSelectionState';
import { bulkFetchTasksAndSequenceCheck } from '../../../utils/TasksUtils';
import { BaseBulkActionButton } from '../BaseBulkActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const BULK_COMPLETE_TASKS_THRESHOLD = 20;
export const COMPLETE_TASK_PROPERTY_UPDATE = [{
  name: STATUS,
  value: COMPLETED
}];
export const DefaultBulkActionsCompleteTasksModalOnSuccess = ({
  count
}) => {
  genericAlertSuccess({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.alerts.tasks.completeTasks.success",
      options: {
        count
      }
    })
  });
};
const DefaultBulkActionsCompleteTasksModalOnFailure = ({
  count,
  error
}) => {
  if (error.status === 403) {
    genericAlertFailure({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkActions.permissions.taskPermissionsFailure.edit",
        options: {
          count
        }
      })
    });
  } else {
    genericAlertFailure({
      message: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "bulkActions.alerts.tasks.generic.failure",
        options: {
          count
        }
      })
    });
  }
};
export const CompleteTasks = ({
  buttonProps
}) => {
  const {
    logFunction,
    onSuccess = DefaultBulkActionsCompleteTasksModalOnSuccess,
    onFailure = DefaultBulkActionsCompleteTasksModalOnFailure
  } = buttonProps;
  const openModal = useBulkActionsOpenModal();
  const {
    selectionIds = []
  } = useBulkActionsSelectionState();
  const count = useBulkActionsNumberOfSelectedObjects();
  const isLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const canBulkEditTasks = useBulkActionsPermissionsForCurrentSelection('canEdit');
  const disabled = isLoading || hasError || !canBulkEditTasks;
  const handleBulkComplete = useOnBulkUpdateTasks(logFunction);
  const onClick = useCallback(() => {
    return bulkFetchTasksAndSequenceCheck(selectionIds, count, {
      logFunction,
      onFailure
    }).then(taskDependencyStep => {
      const taskInSequence = Boolean(taskDependencyStep);
      if (selectionIds.length >= BULK_COMPLETE_TASKS_THRESHOLD || taskInSequence) {
        openModal({
          modalKey: DEFAULT_BULK_ACTIONS_COMPLETE_TASKS_MODAL_KEY,
          props: Object.assign({}, buttonProps, {
            shouldUseSequenceMessage: taskInSequence
          })
        });
      } else {
        handleBulkComplete({
          propertyUpdates: COMPLETE_TASK_PROPERTY_UPDATE,
          onSuccess,
          onFailure
        });
      }
    });
  }, [selectionIds, logFunction, buttonProps, count, openModal, onSuccess, onFailure, handleBulkComplete]);
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    disabled: disabled,
    onClick: onClick,
    icon: "success",
    isLoading: isLoading,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonDisabledTooltips.tasks.generic"
    }),
    "data-test-id": "bulk-actions-complete-tasks",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "bulkActions.buttonLabels.tasks.completeTasks"
    })
  });
};